module.exports = __webpack_public_path__ + "img/status-icn_activated@3x.da11944d.png";